import React from "react";
import { Stack, TextField, Box, Typography, FormControlLabel, Checkbox } from "@mui/material";
import { COLOR_INPUT_STYLE } from "../constants";
import PositionPanel from "./PositionPanel";

export default function ShapePanel({ el, updateEl }) {
    return (
        <Stack spacing={1.5}>
            <Box>
                <Typography variant="caption" color="text.secondary">Remplissage</Typography>
                <FormControlLabel
                    control={
                        <Checkbox
                            size="small"
                            checked={!!el.noFill}
                            onChange={e => updateEl(el.id, { noFill: e.target.checked })}
                        />
                    }
                    label={<Typography variant="body2">Sans remplissage</Typography>}
                    sx={{ ml: 0, mt: 0.5 }}
                />
                {!el.noFill && (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 0.5 }}>
                        <input
                            type="color"
                            value={el.fill}
                            onChange={e => updateEl(el.id, { fill: e.target.value })}
                            style={COLOR_INPUT_STYLE}
                        />
                        <Typography variant="body2">{el.fill}</Typography>
                    </Box>
                )}
            </Box>

            <Box>
                <Typography variant="caption" color="text.secondary">Bordure</Typography>
                <FormControlLabel
                    control={
                        <Checkbox
                            size="small"
                            checked={!!el.noBorder}
                            onChange={e => updateEl(el.id, { noBorder: e.target.checked })}
                        />
                    }
                    label={<Typography variant="body2">Sans bordure</Typography>}
                    sx={{ ml: 0, mt: 0.5 }}
                />
                {!el.noBorder && (
                    <>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 0.5 }}>
                            <input
                                type="color"
                                value={el.stroke}
                                onChange={e => updateEl(el.id, { stroke: e.target.value })}
                                style={COLOR_INPUT_STYLE}
                            />
                            <Typography variant="body2">{el.stroke}</Typography>
                        </Box>
                        <TextField
                            label="Épaisseur bordure"
                            type="number"
                            size="small"
                            value={el.strokeWidth}
                            inputProps={{ min: 0, max: 20 }}
                            onChange={e => updateEl(el.id, { strokeWidth: Number(e.target.value) })}
                            sx={{ mt: 1 }}
                        />
                    </>
                )}
            </Box>

            {el.type === "rect" && (
                <TextField
                    label="Rayon des coins"
                    type="number"
                    size="small"
                    value={el.borderRadius}
                    inputProps={{ min: 0 }}
                    onChange={e => updateEl(el.id, { borderRadius: Number(e.target.value) })}
                />
            )}

            <Box>
                <Typography variant="caption" color="text.secondary">
                    Opacité : {Math.round(el.opacity * 100)}%
                </Typography>
                <input
                    type="range"
                    min="0" max="1" step="0.05"
                    value={el.opacity}
                    onChange={e => updateEl(el.id, { opacity: Number(e.target.value) })}
                    style={{ width: "100%", marginTop: 4 }}
                />
            </Box>

            <PositionPanel el={el} updateEl={updateEl} />
        </Stack>
    );
}
